import { useEffect, useRef } from 'react'

export function usePageVisibility() {
  const originalTitleRef = useRef<string>('')

  useEffect(() => {
    // Zapisz oryginalny tytuł
    originalTitleRef.current = document.title

    const handleVisibilityChange = () => {
      const awayMessage = 'Wróć do nas!' // Tylko polski

      if (document.hidden) {
        // Użytkownik opuścił kartę - zapisz aktualny tytuł przed zmianą
        originalTitleRef.current = document.title
        document.title = awayMessage
      } else {
        // Użytkownik wrócił na kartę
        document.title = originalTitleRef.current
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])
}
